import { render, staticRenderFns } from "./ZoneSelect.vue?vue&type=template&id=2b70871b&scoped=true"
import script from "./ZoneSelect.vue?vue&type=script&lang=js"
export * from "./ZoneSelect.vue?vue&type=script&lang=js"
import style0 from "./ZoneSelect.vue?vue&type=style&index=0&id=2b70871b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70871b",
  null
  
)

export default component.exports